// Module
var code = "<div id=\"queuesPage\"></div> ";
// Exports
module.exports = code;